import { render } from "./Cooperation.vue?vue&type=template&id=1f7ba53d&scoped=true"
import script from "./Cooperation.vue?vue&type=script&lang=js"
export * from "./Cooperation.vue?vue&type=script&lang=js"

import "./Cooperation.vue?vue&type=style&index=0&id=1f7ba53d&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7ba53d"]])

export default __exports__